<template>
  <div class="tag-group">
    <div>{{currentTag.name}}</div>
    <div class="error-message">{{pageError}}</div>
    <loading-icon v-if="loading"></loading-icon>
    <div v-else>
      <div v-if="currentTag.status != 0" class="status">{{tagStatus}}</div>
      <div v-else class="button" @click="selectTag">this is me</div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from '../Shared/LoadingIcon'

export default {
  props: {
    tag: Object,
    advertiserId: [Number, String]
  },

  name: 'tag',

  components: {
    LoadingIcon
  },

  data() {
    return {
      loading: false,
      currentTag: null,
      pageError: null,
    }
  },

  computed: {
    tagStatus() {
      return this.currentTag.status === 'claimed' ? 'selected' : this.currentTag.status
    }
  },

  methods: {
    selectTag() {
      const view = this,
        url = `/brands/${view.advertiserId}/linked_tags`,
        dataToUpdate = {
          tag_id: view.tag.id,
          merchant_id: view.tag.merchant_id,
          advertiser_id: view.advertiserId,
          status: 'claimed'
        }

      view.loading = true

      this.$api.post(url, dataToUpdate)
        .then((response) => {
          const data = response.data
          if (data) {
            view.$emit('refreshAllSections', 'retailers')
            view.currentTag.status = data.status
          } else {
            view.pageError = 'there was an error updating tag, please refresh or contact support'
          }
        })
        .catch((error) => {
          view.pageError = `there was an issue updating tag: ${error}`
        })
        .finally(() => {
          view.loading = false
        })
    },
  },

  created() {
    this.currentTag = this.tag
  },
 }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/colors'

  .tag-group
    display: flex
    justify-content: space-between
    padding: .5rem 2rem

    .status
      color: $title-color
      margin: 0 .35rem 0 0

  .loading-icon
    width: 20px
    margin: 0 1.5rem 0 0
</style>
